<div class="activity-details solo">
        <c-auto-form config="comment.autoFormConfig"></c-auto-form>
</div>